export default __webpack_public_path__ + "static/media/user.724b79cd.png";